import { render, staticRenderFns } from "./MyComponent.vue?vue&type=template&id=0353e230&scoped=true&"
import script from "./MyComponent.vue?vue&type=script&lang=js&"
export * from "./MyComponent.vue?vue&type=script&lang=js&"
import style0 from "./MyComponent.vue?vue&type=style&index=0&id=0353e230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353e230",
  null
  
)

export default component.exports